import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Avatar, Box, Button, Chip, CircularProgress, Dialog,
  DialogContent, Divider, FormControlLabel, IconButton,
  Switch, TextField, Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import InstagramIcon from "@material-ui/icons/Instagram";
import FacebookIcon from "@material-ui/icons/Facebook";
import PhoneIcon from "@material-ui/icons/Phone";
import EmailIcon from "@material-ui/icons/Email";
import PersonIcon from "@material-ui/icons/Person";
import DeviceHubIcon from "@material-ui/icons/DeviceHub";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import LabelIcon from "@material-ui/icons/LocalOffer";
import NoteAddIcon from "@material-ui/icons/NoteAdd";
import AlarmIcon from "@material-ui/icons/Alarm";
import { format, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";
import { toast } from "react-toastify";
import api from "../../services/api";
import { AuthContext } from "../../context/Auth/AuthContext";

const CH = {
  whatsapp:  { Icon: WhatsAppIcon,  color: "#25D366", label: "WhatsApp" },
  instagram: { Icon: InstagramIcon, color: "#E1306C", label: "Instagram" },
  facebook:  { Icon: FacebookIcon,  color: "#1877F2", label: "Facebook" },
};

const PAL = ["#6366f1","#0ea5e9","#10b981","#f59e0b","#ef4444","#8b5cf6","#14b8a6","#f97316"];
function sc(str) {
  let h = 0;
  for (let i = 0; i < (str || "").length; i++) h = (str.charCodeAt(i) + ((h << 5) - h)) | 0;
  return PAL[Math.abs(h) % PAL.length];
}
function ab(n) {
  return (n || "?").split(" ").slice(0, 2).map(function(w) { return w[0] || ""; }).join("").toUpperCase() || "?";
}
function fmtDate(d) {
  if (!d) return "—";
  try { return format(typeof d === "string" ? parseISO(d) : d, "dd/MM/yyyy HH:mm", { locale: ptBR }); }
  catch (e) { return "—"; }
}
const useStyles = makeStyles((theme) => ({
  dialog: { "& .MuiDialog-paper": { borderRadius: 16, maxHeight: "90vh" } },
  header: {
    background: "linear-gradient(135deg, #6366f1 0%, #818cf8 100%)",
    padding: "20px 20px 16px",
    display: "flex",
    alignItems: "flex-start",
    gap: 14,
    position: "relative",
  },
  avatar: {
    width: 56,
    height: 56,
    fontSize: 20,
    fontWeight: 700,
    flexShrink: 0,
    border: "3px solid rgba(255,255,255,0.4)",
  },
  headerInfo: { flex: 1, minWidth: 0 },
  contactName: { fontSize: 18, fontWeight: 800, color: "#fff", lineHeight: 1.25 },
  contactSub: { fontSize: 12, color: "rgba(255,255,255,0.8)", marginTop: 3 },
  closeBtn: { position: "absolute", top: 10, right: 10, color: "rgba(255,255,255,0.9)" },
  chBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    marginTop: 6,
    padding: "2px 8px",
    borderRadius: 20,
    background: "rgba(255,255,255,0.2)",
    "& svg": { fontSize: 13 },
  },
  chLabel: { fontSize: 11, color: "#fff", fontWeight: 600 },
  content: { padding: "0 !important", overflowX: "hidden" },
  section: { padding: "14px 20px" },
  sectionTitle: {
    fontSize: 10,
    fontWeight: 800,
    letterSpacing: 1,
    textTransform: "uppercase",
    color: "#94a3b8",
    marginBottom: 10,
    display: "flex",
    alignItems: "center",
    gap: 6,
    "& svg": { fontSize: 14, color: "#94a3b8" },
  },
  grid2: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "8px 16px",
    [theme.breakpoints.down("xs")]: { gridTemplateColumns: "1fr" },
  },
  infoRow: { display: "flex", alignItems: "flex-start", gap: 7 },
  infoIcon: { fontSize: 14, color: "#94a3b8", marginTop: 1, flexShrink: 0 },
  infoLabel: { fontSize: 10, color: "#94a3b8", lineHeight: 1.3 },
  infoValue: { fontSize: 13, color: "#1e293b", fontWeight: 500, lineHeight: 1.4, wordBreak: "break-word" },
  tagsWrap: { display: "flex", flexWrap: "wrap", gap: 6 },
  tagChip: { height: 24, fontSize: 11, fontWeight: 600, borderRadius: 12 },
  noteCard: {
    background: "#f8fafc",
    borderRadius: 10,
    padding: "10px 12px",
    marginBottom: 8,
    border: "1px solid #e2e8f0",
  },
  noteMeta: { fontSize: 11, color: "#94a3b8", marginBottom: 4 },
  noteBody: { fontSize: 13, color: "#334155", lineHeight: 1.5, whiteSpace: "pre-wrap" },
  addNoteRow: { display: "flex", gap: 8, marginTop: 10, alignItems: "flex-start" },
  addNoteField: { flex: 1, "& .MuiOutlinedInput-root": { borderRadius: 10, fontSize: 13 } },
  addNoteBtn: {
    borderRadius: 10,
    fontWeight: 700,
    fontSize: 12,
    padding: "8px 14px",
    whiteSpace: "nowrap",
    flexShrink: 0,
  },
  reminderRow: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    marginTop: 8,
    flexWrap: "wrap",
  },
  reminderSwitch: {
    "& .MuiFormControlLabel-label": { fontSize: 13, color: "#475569", fontWeight: 500 },
  },
  reminderField: {
    flex: "1 1 200px",
    minWidth: 180,
    "& .MuiOutlinedInput-root": { borderRadius: 8, height: 36, fontSize: 13 },
    "& .MuiInputBase-input": { padding: "8px 10px" },
  },
  reminderBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    marginTop: 6,
    padding: "2px 8px",
    borderRadius: 10,
    background: "#fef9c3",
    color: "#854d0e",
    fontSize: 11,
    fontWeight: 600,
    "& svg": { fontSize: 12 },
  },
  reminderDone: {
    background: "#dcfce7",
    color: "#166534",
  },
  faturaRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px 12px",
    borderRadius: 8,
    border: "1px solid #e2e8f0",
    marginBottom: 6,
    gap: 8,
  },
  faturaDesc: { fontSize: 13, color: "#1e293b", fontWeight: 500, flex: 1, minWidth: 0 },
  faturaVal: { fontSize: 13, fontWeight: 700, color: "#10b981", flexShrink: 0 },
  faturaBadge: { fontSize: 10, fontWeight: 700, padding: "2px 8px", borderRadius: 10 },
  emptyText: { fontSize: 13, color: "#94a3b8", fontStyle: "italic", padding: "4px 0" },
  divider: { margin: "0 !important" },
  loadingBox: { display: "flex", justifyContent: "center", padding: 32 },
}));

const STATUS_COLORS = {
  open: { bg: "#dcfce7", color: "#166534", label: "Aberto" },
  pending: { bg: "#fef9c3", color: "#854d0e", label: "Pendente" },
  closed: { bg: "#f1f5f9", color: "#475569", label: "Fechado" },
};

function InfoItem({ icon: Icon, label, value }) {
  const cls = useStyles();
  if (!value) return null;
  return (
    <Box className={cls.infoRow}>
      <Icon className={cls.infoIcon} />
      <Box>
        <Typography className={cls.infoLabel}>{label}</Typography>
        <Typography className={cls.infoValue}>{value}</Typography>
      </Box>
    </Box>
  );
}

export default function KanbanTicketModal({ open, onClose, ticket }) {
  const cls = useStyles();
  const { user } = useContext(AuthContext);

  const [fullTicket, setFullTicket] = useState(null);
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [newNote, setNewNote] = useState("");
  const [savingNote, setSavingNote] = useState(false);
  const [useReminder, setUseReminder] = useState(false);
  const [reminderAt, setReminderAt] = useState("");

  useEffect(function() {
    if (!open || !ticket) return;
    setFullTicket(null);
    setNotes([]);
    setNewNote("");
    setUseReminder(false);
    setReminderAt("");
    setLoading(true);

    var ticketReq = api.get("/tickets/" + ticket.id);
    var notesReq = api.get("/ticket-notes/list?ticketId=" + ticket.id);

    Promise.all([ticketReq, notesReq]).then(function(results) {
      var ft = results[0].data;
      var ns = results[1].data;
      setFullTicket(ft);
      setNotes(Array.isArray(ns) ? ns : (ns && ns.notes ? ns.notes : []));
    }).catch(function() {
      toast.error("Erro ao carregar dados do ticket");
    }).finally(function() {
      setLoading(false);
    });
  }, [open, ticket]);

  var handleAddNote = function() {
    if (!newNote.trim() || !ticket) return;
    if (useReminder && !reminderAt) {
      toast.warn("Defina a data/hora do lembrete ou desative a opção.");
      return;
    }
    setSavingNote(true);
    var payload = {
      note: newNote.trim(),
      contactId: ticket.contact ? ticket.contact.id : null,
      ticketId: ticket.id,
      companyId: user.companyId,
    };
    if (useReminder && reminderAt) payload.reminderAt = new Date(reminderAt).toISOString();
    api.post("/ticket-notes", payload).then(function(res) {
      setNotes(function(prev) { return [res.data].concat(prev); });
      setNewNote("");
      setUseReminder(false);
      setReminderAt("");
      toast.success("Anotação adicionada!");
    }).catch(function() {
      toast.error("Erro ao salvar anotação");
    }).finally(function() {
      setSavingNote(false);
    });
  };

  if (!ticket) return null;

  var contact = (fullTicket && fullTicket.contact) || ticket.contact || {};
  var ch = CH[(ticket.channel || "whatsapp").toLowerCase()] || CH.whatsapp;
  var ChIcon = ch.Icon;
  var name = contact.name || "Sem nome";
  var status = (fullTicket && fullTicket.status) || ticket.status || "open";
  var statusInfo = STATUS_COLORS[status] || STATUS_COLORS.open;
  var queue = (fullTicket && fullTicket.queue) || ticket.queue;
  var agent = (fullTicket && fullTicket.user) || ticket.user;
  var whatsapp = (fullTicket && fullTicket.whatsapp) || {};
  var allTags = (fullTicket && fullTicket.tags) || ticket.tags || [];
  var normalTags = allTags.filter(function(t) { return !t.kanban; });
  var crmLead = fullTicket && fullTicket.crmLead;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth className={cls.dialog}>

      {/* cabeçalho colorido */}
      <Box className={cls.header}>
        <Avatar
          src={contact.profilePicUrl || contact.urlPicture}
          className={cls.avatar}
          style={{ backgroundColor: sc(name) }}
        >
          {ab(name)}
        </Avatar>
        <Box className={cls.headerInfo}>
          <Typography className={cls.contactName}>{name}</Typography>
          <Typography className={cls.contactSub}>
            Ticket #{ticket.id}
            {" · "}
            <span style={{ background: statusInfo.bg, color: statusInfo.color, padding: "1px 6px", borderRadius: 10, fontWeight: 700, fontSize: 10 }}>
              {statusInfo.label}
            </span>
          </Typography>
          <Box className={cls.chBadge}>
            <ChIcon style={{ color: "#fff" }} />
            <span className={cls.chLabel}>{ch.label}{whatsapp && whatsapp.name ? " · " + whatsapp.name : ""}</span>
          </Box>
        </Box>
        <IconButton className={cls.closeBtn} size="small" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>

      <DialogContent className={cls.content}>
        {loading ? (
          <Box className={cls.loadingBox}><CircularProgress size={32} color="inherit" /></Box>
        ) : (
          <>
            {/* contato + ticket */}
            <Box className={cls.section}>
              <Box className={cls.grid2}>
                <Box>
                  <Typography className={cls.sectionTitle}><PersonIcon />Contato</Typography>
                  <InfoItem icon={PhoneIcon} label="Telefone" value={contact.number} />
                  <InfoItem icon={EmailIcon} label="E-mail" value={contact.email} />
                  {contact.cpfCnpj && <InfoItem icon={PersonIcon} label="CPF/CNPJ" value={contact.cpfCnpj} />}
                  {contact.address && <InfoItem icon={PersonIcon} label="Endereço" value={contact.address} />}
                  {crmLead && <InfoItem icon={PersonIcon} label="Lead CRM" value={crmLead.name + (crmLead.leadStatus ? " · " + crmLead.leadStatus : "")} />}
                </Box>
                <Box>
                  <Typography className={cls.sectionTitle}><AccessTimeIcon />Ticket</Typography>
                  <InfoItem icon={DeviceHubIcon} label="Fila" value={queue ? queue.name : "Sem fila"} />
                  <InfoItem icon={PersonIcon} label="Atendente" value={agent ? agent.name : "Sem atendente"} />
                  <InfoItem icon={AccessTimeIcon} label="Criado em" value={fmtDate(ticket.createdAt)} />
                  <InfoItem icon={AccessTimeIcon} label="Atualizado em" value={fmtDate(ticket.updatedAt)} />
                  {fullTicket && fullTicket.company && (
                    <InfoItem icon={DeviceHubIcon} label="Empresa" value={fullTicket.company.name} />
                  )}
                </Box>
              </Box>
            </Box>

            <Divider className={cls.divider} />

            {/* etiquetas */}
            {normalTags.length > 0 && (
              <>
                <Box className={cls.section}>
                  <Typography className={cls.sectionTitle}><LabelIcon />Etiquetas</Typography>
                  <Box className={cls.tagsWrap}>
                    {normalTags.map(function(tag) {
                      return (
                        <Chip
                          key={tag.id}
                          label={tag.name}
                          size="small"
                          className={cls.tagChip}
                          style={{ backgroundColor: tag.color || "#e2e8f0", color: "#fff" }}
                        />
                      );
                    })}
                  </Box>
                </Box>
                <Divider className={cls.divider} />
              </>
            )}

            {/* anotações */}
            <Box className={cls.section}>
              <Typography className={cls.sectionTitle}><NoteAddIcon />Anotações</Typography>
              {notes.length === 0 && (
                <Typography className={cls.emptyText}>Nenhuma anotação registrada.</Typography>
              )}
              {notes.map(function(note) {
                var hasReminder = !!note.reminderAt;
                var isDone = !!note.reminderDone;
                return (
                  <Box key={note.id} className={cls.noteCard}>
                    <Typography className={cls.noteMeta}>
                      {note.user ? note.user.name : "Sistema"}
                      {" · "}
                      {fmtDate(note.createdAt)}
                    </Typography>
                    <Typography className={cls.noteBody}>{note.note}</Typography>
                    {hasReminder && (
                      <Box className={cls.reminderBadge + (isDone ? " " + cls.reminderDone : "")}>
                        <AlarmIcon />
                        {isDone ? "Lembrete concluído · " : "Lembrete · "}
                        {fmtDate(note.reminderAt)}
                      </Box>
                    )}
                  </Box>
                );
              })}

              {/* formulário nova anotação */}
              <Box style={{ marginTop: 12 }}>
                <TextField
                  className={cls.addNoteField}
                  variant="outlined"
                  size="small"
                  multiline
                  rows={2}
                  placeholder="Adicionar anotação..."
                  value={newNote}
                  fullWidth
                  onChange={function(e) { setNewNote(e.target.value); }}
                />
                <Box className={cls.reminderRow}>
                  <FormControlLabel
                    className={cls.reminderSwitch}
                    control={
                      <Switch
                        size="small"
                        color="primary"
                        checked={useReminder}
                        onChange={function(e) {
                          setUseReminder(e.target.checked);
                          if (!e.target.checked) setReminderAt("");
                        }}
                      />
                    }
                    label="Lembrete"
                  />
                  {useReminder && (
                    <TextField
                      className={cls.reminderField}
                      variant="outlined"
                      size="small"
                      type="datetime-local"
                      value={reminderAt}
                      onChange={function(e) { setReminderAt(e.target.value); }}
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ min: new Date().toISOString().slice(0, 16) }}
                    />
                  )}
                  <Button
                    className={cls.addNoteBtn}
                    variant="contained"
                    color="primary"
                    disabled={!newNote.trim() || savingNote}
                    onClick={handleAddNote}
                    style={{ marginLeft: "auto" }}
                  >
                    {savingNote ? "..." : "Salvar anotação"}
                  </Button>
                </Box>
              </Box>
            </Box>

          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
